module.exports = __webpack_public_path__ + "static/media/insurance.456c403a.svg";